<template>
  <div>
    <router-view></router-view>
    <BottomSheet></BottomSheet>
  </div>
</template>

<script>

import BottomSheet from '../BottomSheet';
import ListDataEditor from '../content/ListDataEditor';
import CustomersList from './CustomersList'

export default {
  name: "CustomersPage",
  components: {
    BottomSheet
  },
  routes: [
    {
      path: "",
      redirect: "/billing/customers/list"
    },
    {      
      path: "list",
      components: {
        default: CustomersList,
      },
      name: "Billing customers list",
    },
    {
      path: "list/:id/data/new",
      components: {
        default: CustomersList,
        bottomEditor: ListDataEditor
      },
      props: {
        default: true,
        bottomEditor: true
      },
      name: "Billing customers new"
    },
    {
      path: "list/:id/data/edit/:data_id",
      components: {
        default: CustomersList,
        bottomEditor: ListDataEditor
      },
      props: {
        default: true,
        bottomEditor: true
      },
      name: "Billing customers edit"
    },
   
  ]
}
</script>